import { render } from "./create-organisation.vue?vue&type=template&id=669ad591"
import script from "./create-organisation.vue?vue&type=script&lang=js"
export * from "./create-organisation.vue?vue&type=script&lang=js"

import "./create-organisation.vue?vue&type=style&index=0&id=669ad591&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__